import type { TableOfContentsPageNumberCreationPanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useCreateTableOfContentsPageNumberFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: TableOfContentsPageNumberCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function TableOfContentsPageNumberCreationPanel({
  fragment,
  onDelete,
}: Props) {
  const { t } = useTranslation();
  const [createAttribute] =
    useCreateTableOfContentsPageNumberFromPanelMutation();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("TableOfContentsPageNumberCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
